/**
 * @fileoverview gRPC-Web generated client stub for model
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: model/control.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var account_account_pb = require('../account/account_pb.js')

var common_collections_pb = require('../common/collections_pb.js')

var common_model_pb = require('../common/model_pb.js')

var common_grc_platform_pb = require('../common/grc_platform_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var model_department_pb = require('../model/department_pb.js')

var model_policy_pb = require('../model/policy_pb.js')

var model_filters_pb = require('../model/filters_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.model = require('./control_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.model.ControlServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.model.ControlServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.GetStatusBreakdownRequest,
 *   !proto.model.GetStatusBreakdownResponse>}
 */
const methodDescriptor_ControlService_GetStatusBreakdown = new grpc.web.MethodDescriptor(
  '/model.ControlService/GetStatusBreakdown',
  grpc.web.MethodType.UNARY,
  proto.model.GetStatusBreakdownRequest,
  proto.model.GetStatusBreakdownResponse,
  /**
   * @param {!proto.model.GetStatusBreakdownRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.GetStatusBreakdownResponse.deserializeBinary
);


/**
 * @param {!proto.model.GetStatusBreakdownRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.GetStatusBreakdownResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.GetStatusBreakdownResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.getStatusBreakdown =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/GetStatusBreakdown',
      request,
      metadata || {},
      methodDescriptor_ControlService_GetStatusBreakdown,
      callback);
};


/**
 * @param {!proto.model.GetStatusBreakdownRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.GetStatusBreakdownResponse>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.getStatusBreakdown =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/GetStatusBreakdown',
      request,
      metadata || {},
      methodDescriptor_ControlService_GetStatusBreakdown);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.GetPreparedControlsBreakdownRequest,
 *   !proto.model.GetPreparedControlsBreakdownResponse>}
 */
const methodDescriptor_ControlService_GetPreparedControlsBreakdown = new grpc.web.MethodDescriptor(
  '/model.ControlService/GetPreparedControlsBreakdown',
  grpc.web.MethodType.UNARY,
  proto.model.GetPreparedControlsBreakdownRequest,
  proto.model.GetPreparedControlsBreakdownResponse,
  /**
   * @param {!proto.model.GetPreparedControlsBreakdownRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.GetPreparedControlsBreakdownResponse.deserializeBinary
);


/**
 * @param {!proto.model.GetPreparedControlsBreakdownRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.GetPreparedControlsBreakdownResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.GetPreparedControlsBreakdownResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.getPreparedControlsBreakdown =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/GetPreparedControlsBreakdown',
      request,
      metadata || {},
      methodDescriptor_ControlService_GetPreparedControlsBreakdown,
      callback);
};


/**
 * @param {!proto.model.GetPreparedControlsBreakdownRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.GetPreparedControlsBreakdownResponse>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.getPreparedControlsBreakdown =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/GetPreparedControlsBreakdown',
      request,
      metadata || {},
      methodDescriptor_ControlService_GetPreparedControlsBreakdown);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.BulkUpdateControlsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ControlService_BulkUpdateControls = new grpc.web.MethodDescriptor(
  '/model.ControlService/BulkUpdateControls',
  grpc.web.MethodType.UNARY,
  proto.model.BulkUpdateControlsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.BulkUpdateControlsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.BulkUpdateControlsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.bulkUpdateControls =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/BulkUpdateControls',
      request,
      metadata || {},
      methodDescriptor_ControlService_BulkUpdateControls,
      callback);
};


/**
 * @param {!proto.model.BulkUpdateControlsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.bulkUpdateControls =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/BulkUpdateControls',
      request,
      metadata || {},
      methodDescriptor_ControlService_BulkUpdateControls);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlReadOnlyFieldsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ControlService_UpdateControlReadOnlyFields = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlReadOnlyFields',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlReadOnlyFieldsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.UpdateControlReadOnlyFieldsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlReadOnlyFieldsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlReadOnlyFields =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlReadOnlyFields',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlReadOnlyFields,
      callback);
};


/**
 * @param {!proto.model.UpdateControlReadOnlyFieldsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlReadOnlyFields =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlReadOnlyFields',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlReadOnlyFields);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlProcedureReadOnlyFieldsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ControlService_UpdateControlProcedureReadOnlyFields = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlProcedureReadOnlyFields',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlProcedureReadOnlyFieldsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.UpdateControlProcedureReadOnlyFieldsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlProcedureReadOnlyFieldsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlProcedureReadOnlyFields =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlProcedureReadOnlyFields',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlProcedureReadOnlyFields,
      callback);
};


/**
 * @param {!proto.model.UpdateControlProcedureReadOnlyFieldsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlProcedureReadOnlyFields =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlProcedureReadOnlyFields',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlProcedureReadOnlyFields);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.ToggleUsesNewAuditScanRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ControlService_ToggleUsesNewAuditScan = new grpc.web.MethodDescriptor(
  '/model.ControlService/ToggleUsesNewAuditScan',
  grpc.web.MethodType.UNARY,
  proto.model.ToggleUsesNewAuditScanRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.ToggleUsesNewAuditScanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.ToggleUsesNewAuditScanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.toggleUsesNewAuditScan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/ToggleUsesNewAuditScan',
      request,
      metadata || {},
      methodDescriptor_ControlService_ToggleUsesNewAuditScan,
      callback);
};


/**
 * @param {!proto.model.ToggleUsesNewAuditScanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.toggleUsesNewAuditScan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/ToggleUsesNewAuditScan',
      request,
      metadata || {},
      methodDescriptor_ControlService_ToggleUsesNewAuditScan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlFieldsRequest,
 *   !proto.model.Control>}
 */
const methodDescriptor_ControlService_UpdateControlFields = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlFields',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlFieldsRequest,
  proto.model.Control,
  /**
   * @param {!proto.model.UpdateControlFieldsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.Control.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlFieldsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.Control)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.Control>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlFields =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlFields',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlFields,
      callback);
};


/**
 * @param {!proto.model.UpdateControlFieldsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.Control>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlFields =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlFields',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlFields);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.DismissControlRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ControlService_DismissControl = new grpc.web.MethodDescriptor(
  '/model.ControlService/DismissControl',
  grpc.web.MethodType.UNARY,
  proto.model.DismissControlRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.DismissControlRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.DismissControlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.dismissControl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/DismissControl',
      request,
      metadata || {},
      methodDescriptor_ControlService_DismissControl,
      callback);
};


/**
 * @param {!proto.model.DismissControlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.dismissControl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/DismissControl',
      request,
      metadata || {},
      methodDescriptor_ControlService_DismissControl);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlSuggestedEvidenceRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ControlService_UpdateControlSuggestedEvidence = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlSuggestedEvidence',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlSuggestedEvidenceRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.UpdateControlSuggestedEvidenceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlSuggestedEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlSuggestedEvidence =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlSuggestedEvidence',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlSuggestedEvidence,
      callback);
};


/**
 * @param {!proto.model.UpdateControlSuggestedEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlSuggestedEvidence =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlSuggestedEvidence',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlSuggestedEvidence);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlSuggestedTestsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ControlService_UpdateControlSuggestedTests = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlSuggestedTests',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlSuggestedTestsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.UpdateControlSuggestedTestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlSuggestedTestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlSuggestedTests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlSuggestedTests',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlSuggestedTests,
      callback);
};


/**
 * @param {!proto.model.UpdateControlSuggestedTestsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlSuggestedTests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlSuggestedTests',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlSuggestedTests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.ListControlTestProcedureVersionsRequest,
 *   !proto.model.ListControlTestProcedureVersionsResponse>}
 */
const methodDescriptor_ControlService_ListControlTestProcedureVersions = new grpc.web.MethodDescriptor(
  '/model.ControlService/ListControlTestProcedureVersions',
  grpc.web.MethodType.UNARY,
  proto.model.ListControlTestProcedureVersionsRequest,
  proto.model.ListControlTestProcedureVersionsResponse,
  /**
   * @param {!proto.model.ListControlTestProcedureVersionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.ListControlTestProcedureVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.model.ListControlTestProcedureVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.ListControlTestProcedureVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.ListControlTestProcedureVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.listControlTestProcedureVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/ListControlTestProcedureVersions',
      request,
      metadata || {},
      methodDescriptor_ControlService_ListControlTestProcedureVersions,
      callback);
};


/**
 * @param {!proto.model.ListControlTestProcedureVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.ListControlTestProcedureVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.listControlTestProcedureVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/ListControlTestProcedureVersions',
      request,
      metadata || {},
      methodDescriptor_ControlService_ListControlTestProcedureVersions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.CreateControlTestProcedureRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ControlService_CreateControlTestProcedure = new grpc.web.MethodDescriptor(
  '/model.ControlService/CreateControlTestProcedure',
  grpc.web.MethodType.UNARY,
  proto.model.CreateControlTestProcedureRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.CreateControlTestProcedureRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.CreateControlTestProcedureRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.createControlTestProcedure =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/CreateControlTestProcedure',
      request,
      metadata || {},
      methodDescriptor_ControlService_CreateControlTestProcedure,
      callback);
};


/**
 * @param {!proto.model.CreateControlTestProcedureRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.createControlTestProcedure =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/CreateControlTestProcedure',
      request,
      metadata || {},
      methodDescriptor_ControlService_CreateControlTestProcedure);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.DeleteControlTestProcedureRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ControlService_DeleteControlTestProcedure = new grpc.web.MethodDescriptor(
  '/model.ControlService/DeleteControlTestProcedure',
  grpc.web.MethodType.UNARY,
  proto.model.DeleteControlTestProcedureRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.DeleteControlTestProcedureRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.DeleteControlTestProcedureRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.deleteControlTestProcedure =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/DeleteControlTestProcedure',
      request,
      metadata || {},
      methodDescriptor_ControlService_DeleteControlTestProcedure,
      callback);
};


/**
 * @param {!proto.model.DeleteControlTestProcedureRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.deleteControlTestProcedure =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/DeleteControlTestProcedure',
      request,
      metadata || {},
      methodDescriptor_ControlService_DeleteControlTestProcedure);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlPolicyRequest,
 *   !proto.model.Control>}
 */
const methodDescriptor_ControlService_UpdateControlPolicy = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlPolicy',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlPolicyRequest,
  proto.model.Control,
  /**
   * @param {!proto.model.UpdateControlPolicyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.Control.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlPolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.Control)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.Control>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlPolicy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlPolicy',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlPolicy,
      callback);
};


/**
 * @param {!proto.model.UpdateControlPolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.Control>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlPolicy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlPolicy',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlPolicy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.ListControlPoliciesRequest,
 *   !proto.model.PolicyRecords>}
 */
const methodDescriptor_ControlService_ListControlPolicies = new grpc.web.MethodDescriptor(
  '/model.ControlService/ListControlPolicies',
  grpc.web.MethodType.UNARY,
  proto.model.ListControlPoliciesRequest,
  model_policy_pb.PolicyRecords,
  /**
   * @param {!proto.model.ListControlPoliciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  model_policy_pb.PolicyRecords.deserializeBinary
);


/**
 * @param {!proto.model.ListControlPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyRecords)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyRecords>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.listControlPolicies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/ListControlPolicies',
      request,
      metadata || {},
      methodDescriptor_ControlService_ListControlPolicies,
      callback);
};


/**
 * @param {!proto.model.ListControlPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyRecords>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.listControlPolicies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/ListControlPolicies',
      request,
      metadata || {},
      methodDescriptor_ControlService_ListControlPolicies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.BatchListControlPoliciesRequest,
 *   !proto.model.BatchListControlPoliciesResponse>}
 */
const methodDescriptor_ControlService_BatchListControlPolicies = new grpc.web.MethodDescriptor(
  '/model.ControlService/BatchListControlPolicies',
  grpc.web.MethodType.UNARY,
  proto.model.BatchListControlPoliciesRequest,
  proto.model.BatchListControlPoliciesResponse,
  /**
   * @param {!proto.model.BatchListControlPoliciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.BatchListControlPoliciesResponse.deserializeBinary
);


/**
 * @param {!proto.model.BatchListControlPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.BatchListControlPoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.BatchListControlPoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.batchListControlPolicies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/BatchListControlPolicies',
      request,
      metadata || {},
      methodDescriptor_ControlService_BatchListControlPolicies,
      callback);
};


/**
 * @param {!proto.model.BatchListControlPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.BatchListControlPoliciesResponse>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.batchListControlPolicies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/BatchListControlPolicies',
      request,
      metadata || {},
      methodDescriptor_ControlService_BatchListControlPolicies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.AddControlPolicyRequest,
 *   !proto.model.Control>}
 */
const methodDescriptor_ControlService_AddControlPolicy = new grpc.web.MethodDescriptor(
  '/model.ControlService/AddControlPolicy',
  grpc.web.MethodType.UNARY,
  proto.model.AddControlPolicyRequest,
  proto.model.Control,
  /**
   * @param {!proto.model.AddControlPolicyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.Control.deserializeBinary
);


/**
 * @param {!proto.model.AddControlPolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.Control)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.Control>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.addControlPolicy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/AddControlPolicy',
      request,
      metadata || {},
      methodDescriptor_ControlService_AddControlPolicy,
      callback);
};


/**
 * @param {!proto.model.AddControlPolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.Control>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.addControlPolicy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/AddControlPolicy',
      request,
      metadata || {},
      methodDescriptor_ControlService_AddControlPolicy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.RemoveControlPolicyRequest,
 *   !proto.model.Control>}
 */
const methodDescriptor_ControlService_RemoveControlPolicy = new grpc.web.MethodDescriptor(
  '/model.ControlService/RemoveControlPolicy',
  grpc.web.MethodType.UNARY,
  proto.model.RemoveControlPolicyRequest,
  proto.model.Control,
  /**
   * @param {!proto.model.RemoveControlPolicyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.Control.deserializeBinary
);


/**
 * @param {!proto.model.RemoveControlPolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.Control)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.Control>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.removeControlPolicy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/RemoveControlPolicy',
      request,
      metadata || {},
      methodDescriptor_ControlService_RemoveControlPolicy,
      callback);
};


/**
 * @param {!proto.model.RemoveControlPolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.Control>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.removeControlPolicy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/RemoveControlPolicy',
      request,
      metadata || {},
      methodDescriptor_ControlService_RemoveControlPolicy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlFrameworksRequest,
 *   !proto.model.Control>}
 */
const methodDescriptor_ControlService_UpdateControlFrameworks = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlFrameworks',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlFrameworksRequest,
  proto.model.Control,
  /**
   * @param {!proto.model.UpdateControlFrameworksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.Control.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlFrameworksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.Control)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.Control>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlFrameworks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlFrameworks',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlFrameworks,
      callback);
};


/**
 * @param {!proto.model.UpdateControlFrameworksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.Control>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlFrameworks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlFrameworks',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlFrameworks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlObjectiveRequest,
 *   !proto.model.Control>}
 */
const methodDescriptor_ControlService_UpdateControlObjective = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlObjective',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlObjectiveRequest,
  proto.model.Control,
  /**
   * @param {!proto.model.UpdateControlObjectiveRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.Control.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlObjectiveRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.Control)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.Control>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlObjective =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlObjective',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlObjective,
      callback);
};


/**
 * @param {!proto.model.UpdateControlObjectiveRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.Control>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlObjective =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlObjective',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlObjective);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlProcedureRequest,
 *   !proto.model.Control>}
 */
const methodDescriptor_ControlService_UpdateControlProcedure = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlProcedure',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlProcedureRequest,
  proto.model.Control,
  /**
   * @param {!proto.model.UpdateControlProcedureRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.Control.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlProcedureRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.Control)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.Control>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlProcedure =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlProcedure',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlProcedure,
      callback);
};


/**
 * @param {!proto.model.UpdateControlProcedureRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.Control>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlProcedure =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlProcedure',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlProcedure);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlGeneralGuidanceRequest,
 *   !proto.model.Control>}
 */
const methodDescriptor_ControlService_UpdateControlGeneralGuidance = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlGeneralGuidance',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlGeneralGuidanceRequest,
  proto.model.Control,
  /**
   * @param {!proto.model.UpdateControlGeneralGuidanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.Control.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlGeneralGuidanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.Control)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.Control>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlGeneralGuidance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlGeneralGuidance',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlGeneralGuidance,
      callback);
};


/**
 * @param {!proto.model.UpdateControlGeneralGuidanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.Control>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlGeneralGuidance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlGeneralGuidance',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlGeneralGuidance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdateControlLabelsRequest,
 *   !proto.model.Control>}
 */
const methodDescriptor_ControlService_UpdateControlLabels = new grpc.web.MethodDescriptor(
  '/model.ControlService/UpdateControlLabels',
  grpc.web.MethodType.UNARY,
  proto.model.UpdateControlLabelsRequest,
  proto.model.Control,
  /**
   * @param {!proto.model.UpdateControlLabelsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.Control.deserializeBinary
);


/**
 * @param {!proto.model.UpdateControlLabelsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.Control)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.Control>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.ControlServiceClient.prototype.updateControlLabels =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.ControlService/UpdateControlLabels',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlLabels,
      callback);
};


/**
 * @param {!proto.model.UpdateControlLabelsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.Control>}
 *     Promise that resolves to the response
 */
proto.model.ControlServicePromiseClient.prototype.updateControlLabels =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.ControlService/UpdateControlLabels',
      request,
      metadata || {},
      methodDescriptor_ControlService_UpdateControlLabels);
};


module.exports = proto.model;

